import {
  AlertTriangle,
  FileText,
  Package,
  PackageSearch,
  Ban,
  MoreHorizontal,
  type LucideIcon,
} from 'lucide-react';

/**
 * Motifs de remboursement — surface VENDEUR.
 *
 * Liste PLATE et NEUTRE (aucune conséquence de répartition affichée) : le
 * vendeur, partie intéressée, ne doit pas pouvoir cocher ce qui l'avantage.
 * Même esprit que la liste acheteur, mais « Mauvais produit ou manquant » est
 * SÉPARÉ en deux motifs (le vendeur distingue les deux cas à l'expédition).
 *
 * Les `key` sont des motifs d'AFFICHAGE (pas des valeurs d'enum serveur) : à
 * l'envoi, le motif réseau est NORMALISÉ en `requested_by_seller` et le libellé
 * choisi part dans le commentaire. Le motif d'un vendeur ne pilote donc jamais
 * la répartition (ADR-027, isAdmin=false) — seul l'admin l'arbitre.
 */
export interface SellerRefundReasonOption {
  key: string;
  labelKey: string;
  defaultLabel: string;
  icon: LucideIcon;
}

export const SELLER_REFUND_REASONS: SellerRefundReasonOption[] = [
  { key: 'damaged', labelKey: 'orders.refund.reasons.damaged', defaultLabel: 'Produit endommagé', icon: AlertTriangle },
  { key: 'not_conforming', labelKey: 'orders.refund.reasons.notConforming', defaultLabel: 'Produit non conforme', icon: FileText },
  { key: 'wrong_product', labelKey: 'orders.refund.reasons.wrongProduct', defaultLabel: 'Mauvais produit', icon: Package },
  { key: 'missing_product', labelKey: 'orders.refund.reasons.missingProduct', defaultLabel: 'Produit manquant', icon: PackageSearch },
  { key: 'out_of_stock', labelKey: 'orders.refund.reasons.outOfStock', defaultLabel: 'Rupture de stock', icon: Ban },
  { key: 'other', labelKey: 'orders.refund.reasons.other', defaultLabel: 'Autre motif', icon: MoreHorizontal },
];

/** Motif RÉSEAU neutre du vendeur — ne dérive aucune politique (isAdmin=false). */
export const SELLER_WIRE_REASON = 'requested_by_seller';

export interface SellerRefundPayload {
  amount: number;
  reason: string;
  comment?: string;
}

/**
 * Construit le payload `{ amount, reason, comment? }`. Le motif réseau est
 * TOUJOURS `requested_by_seller` ; le libellé choisi (+ le texte libre éventuel)
 * est reporté dans le commentaire pour l'audit — le motif réel n'est donc pas
 * perdu, mais il n'assigne aucune faute.
 */
export function buildSellerRefundPayload(input: {
  amount: number;
  reasonKey: string;
  reasonLabel: string;
  comment?: string;
}): SellerRefundPayload {
  const note = [input.reasonLabel, input.comment?.trim()].filter(Boolean).join(' — ');
  return {
    amount: input.amount,
    reason: SELLER_WIRE_REASON,
    ...(note ? { comment: note } : {}),
  };
}
